import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Panel from "../../../ui/Panel/Panel";
import SecurityMethodItem from "./SecurityMethodItem/SecurityMethodItem";
import classes from "./SecurityMethodsModal.module.scss";
import { FaTimes } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import messages from "./module/messages";
import { useHorizontalScroll } from "../../../hooks/useHorizontalScroll";

interface SecurityMethodsModalProps {
  show: boolean;
  onClose: () => void;
  onChooseMethod: (
    method: "mfaRequired" | "securityQuestionsRequired" | "uigpOTPRequired"
  ) => void;
  showMfa?: boolean;
  showQuest?: boolean;
  showUigp?: boolean;
}

function SecurityMethodsModal({
  show,
  onClose,
  onChooseMethod,
  showMfa = false,
  showQuest = false,
  showUigp = false,
}: SecurityMethodsModalProps) {
  const scrollRef = useHorizontalScroll();

  useEffect(() => {
    if (showMfa && !showQuest && !showUigp) {
      onChooseMethod("mfaRequired");
    } else if (!showMfa && showQuest && !showUigp) {
      onChooseMethod("securityQuestionsRequired");
    } else if (!showMfa && !showQuest && showUigp) {
      onChooseMethod("uigpOTPRequired");
    }
  }, []);
  return (
    <Modal
      show={show}
      size={"xl"}
      onHide={onClose}
      centered
      contentClassName={classes.content}
    >
      <Modal.Header className={classes.header}>
        <FaTimes onClick={onClose} className={classes.closeIcon} />
      </Modal.Header>
      <Modal.Body>
        <h3 className={classes.title}>
          <FormattedMessage {...messages.title} />
        </h3>
        <div ref={scrollRef} className={classes.methodsWrapper}>
          {showUigp && (
            <SecurityMethodItem
              method="uigpOTPRequired"
              onSelect={(
                m:
                  | "mfaRequired"
                  | "securityQuestionsRequired"
                  | "uigpOTPRequired"
              ) => onChooseMethod(m)}
            />
          )}
          {showQuest && (
            <SecurityMethodItem
              method="securityQuestionsRequired"
              onSelect={(
                m:
                  | "mfaRequired"
                  | "securityQuestionsRequired"
                  | "uigpOTPRequired"
              ) => onChooseMethod(m)}
            />
          )}
          {showMfa && (
            <SecurityMethodItem
              method="mfaRequired"
              onSelect={(
                m:
                  | "mfaRequired"
                  | "securityQuestionsRequired"
                  | "uigpOTPRequired"
              ) => onChooseMethod(m)}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SecurityMethodsModal;
